import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { AssestDetailsRow } from './assest-details-row';
import { IAssetDetailsTransactionSchema } from '../types';

const TABLE_HEAD = [
  { id: 'id', label: 'Id', align: 'center', sortable: false },
  { id: 'PartName', label: 'Part Name', align: 'center', sortable: false },
  { id: 'status', label: 'Status', align: 'center', sortable: false },
  { id: 'repairingAt', label: 'Repairing At', align: 'center', sortable: false },
  { id: 'about', label: 'About', align: 'center', sortable: false },
];

interface Props {
  tableProps: TableProps;
  data?: IAssetDetailsTransactionSchema[];
  loading?: boolean;
}

const AssestDetailsList = ({ tableProps, data, loading }: Props) => {
  return (
    <PaginatedTable<IAssetDetailsTransactionSchema>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={data}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => <AssestDetailsRow row={row} />}
    </PaginatedTable>
  );
};

export { AssestDetailsList };
